intra_module.factory('Message', function($resource, api_url) {
    const url    = `${api_url}/messages/:id`;
    const params =
        {id: '@id'};
    const actions = {
        query: {
            method:  'GET',
            isArray: true,
            url:     `${api_url}/conversations/:conversation_id/messages`,
            params: {
                conversation_id: '@conversation_id'
            }
        },
        save: {
            method: 'POST',
            url:    `${api_url}/conversations/:conversation_id/messages`,
            params: {
                conversation_id: '@conversation_id'
            }
        },
        update: {
            method: 'PUT'
        },
        read: {
            method: 'PUT',
            url:    `${api_url}/messages/:id/read`
        },

        getLikes: {
            method:  'GET',
            url:     `${api_url}/conversations/:conversation_id/messages/:message_id/likes`,
            isArray: false,
            params: {
                message_id:      '@message_id',
                conversation_id: '@conversation_id'
            }
        },

        addLike: {
            method:  'POST',
            url:     `${api_url}/conversations/:conversation_id/messages/:message_id/like`,
            isArray: false,
            params: {
                message_id:      '@message_id',
                conversation_id: '@conversation_id',
                like:            '@like'
            }
        },

        removeLike: {
            method:  'DELETE',
            url:     `${api_url}/conversations/:conversation_id/messages/:message_id/like`,
            isArray: false,
            params: {
                message_id:      '@message_id',
                conversation_id: '@conversation_id'
            }
        },

        getView: {
            method:  'GET',
            url:     `${api_url}/conversations/:conversation_id/messages/:message_id/views`,
            isArray: false,
            params: {
                message_id:      '@message_id',
                conversation_id: '@conversation_id'
            }
        },

        view: {
            method:  'PUT',
            url:     `${api_url}/conversations/:conversation_id/messages/:message_id/view`,
            isArray: true,
            params: {
                message_id:      '@message_id',
                conversation_id: '@conversation_id'
            }
        }
    };

    return $resource(url, params, actions);
});
